import imagekit from "./imagekit";
import { API_URL } from "./api-base-url";

export const uploadImage = async (imageFile) => {
  if (!imageFile) {
    throw new Error("No image selected");
  }

  console.log("Starting ImageKit upload:", {
    name: imageFile.name,
    size: `${(imageFile.size / 1024 / 1024).toFixed(2)} MB`,
    type: imageFile.type,
  });

  // Get ImageKit authentication
  console.log("Requesting ImageKit authentication...");

  const authRes = await fetch(`${API_URL}/api/auth-image`, {
    method: "GET",
    credentials: "include",
  });

  console.log("ImageKit auth response:", authRes.status);

  if (!authRes.ok) {
    throw new Error("Failed to authenticate with ImageKit");
  }

  const { token, signature, expire } = await authRes.json();

  console.log("ImageKit authentication received");

  return new Promise((resolve, reject) => {
    console.log("Starting ImageKit upload...");

    imagekit.upload(
      {
        file: imageFile,
        fileName: imageFile.name,
        useUniqueFileName: true,
        tags: ["product-image"],
        isPrivateFile: false,
        token,
        signature,
        expire,
      },

      (err, result) => {
        if (err) {
          console.error("ImageKit Upload Error:", err);
          reject(err);
          return;
        }

        console.log("ImageKit upload successful:", result.url);

        resolve(result.url);
      }
    );
  });
};